'use strict';

var React = require('react');

var SvgPaginationStartMinor = function SvgPaginationStartMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6 4a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0v-10a1 1 0 0 1 1-1zm7.219.376a1 1 0 1 1 1.562 1.249l-3.501 4.375 3.5 4.375a1 1 0 1 1-1.562 1.249l-4-5a1 1 0 0 1 0-1.25l4-5z"
  }));
};

exports.SvgPaginationStartMinor = SvgPaginationStartMinor;
